import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { authService } from '..';
import { authActionCreators } from '../ducks/auth';
import { coreActionCreators } from '../ducks/core';
import { useMiaDispatch, useMiaSelector } from './hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonPad: {
      padding: theme.spacing(2)
    },
    container: {
      flexGrow: 1,
      margin: 0,
      overflow: 'hidden',
      width: '100%'
    },
    fullHeight: {
      height: '100vh'
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      height: 200,
      padding: 10,
      textAlign: 'center'
    },
    noPadding: { padding: 0 }
  })
);

interface ILoginPageProps {}

export const LoginPage = React.memo<ILoginPageProps>(() => {
  const classes = useStyles();
  const [attemptingLogin, setAttemptingLogin] = React.useState(true);
  const { loginFailed, inProcess } = useMiaSelector(state => state.auth);
  const login = useMiaDispatch(() => authActionCreators.login());
  const initApp = useMiaDispatch(() => coreActionCreators.initApp());
  React.useEffect(() => {
    async function init() {
      if (!loginFailed) {
        const isLoggedIn = await authService.isUserLoggedIn();
        if (isLoggedIn) {
          initApp();
        } else {
          setAttemptingLogin(false);
        }
      }
    }
    init();
  }, []);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12} className={classes.noPadding}>
        <Grid container className={classes.fullHeight} alignItems="center" direction="row" justify="center">
          <Grid item lg={2} md={3} sm={5} xs={10}>
            <Paper>
              <div className={classes.header}>
                <img
                  src="https://static.shoremaster.com/img/wfb_llc_white.png"
                  style={{ objectFit: 'scale-down', width: '100%', height: 'auto' }}
                />
              </div>
              <div className={classes.buttonPad}>
                <Button
                  color="primary"
                  onClick={login}
                  disabled={inProcess || (attemptingLogin && !loginFailed)}
                  variant="contained"
                  fullWidth
                >
                  Login
                </Button>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
});
